import { Path, Svg, View } from '../../../compiler'

const HandThumbDownIcon = ({ style, color = 'currentColor' }) => {
  return (
    <View style={style}>
      <Svg
        xmlns='http://www.w3.org/2000/svg'
        viewBox='0 0 20 20'
        fill={color}
        className='size-5'
      >
        <Path d='M18.905 12.75a1.25 1.25 0 1 1-2.5 0v-7.5a1.25 1.25 0 0 1 2.5 0v7.5ZM8.905 17v1.3c0 .268-.14.526-.395.607A2 2 0 0 1 5.905 17c0-.995.182-1.948.514-2.826.204-.54-.166-1.174-.744-1.174h-2.52c-1.243 0-2.261-1.01-2.146-2.247.193-2.08.651-4.082 1.341-5.974C2.752 3.678 3.833 3 5.005 3h3.192a3 3 0 0 1 1.341.317l2.734 1.366A3 3 0 0 0 13.613 5h1.292v7h-.963c-.685 0-1.258.482-1.612 1.068a4.01 4.01 0 0 1-2.166 1.73c-.432.143-.853.386-1.011.814-.16.432-.248.9-.248 1.388Z' />
      </Svg>
    </View>
  )
}

export default HandThumbDownIcon
